import { FC } from 'react';
import { TNavLink } from '@/features/contentful/components/NavLinksWithContent/NavLinksWithContent';
import Link from 'next/link';
import './NavLinkItem.scss';
import CustomImage from '@/components/CustomImage/CustomImage';

interface NavLinkItemProps {
    navLinkItem: TNavLink;
}

const NavLinkItem: FC<NavLinkItemProps> = ({ navLinkItem }) => {
    const { label, path, image } = navLinkItem;
    return (
        <Link href={path}>
            <div className="nav-container lg:tw-w-[252px] tw-h-[173px]  md:tw-h-[127px]">
                <CustomImage
                    src={`https:${image?.fields?.file?.url}?fm=webp&w=600`}
                    alt={image?.fields?.title ?? label}
                    width={image?.fields?.file.details.image.width}
                    height={image?.fields?.file.details.image.height}
                    className="nav-image tw-object-cover"
                />
                <div className="label-txt tw-p-[10px]">
                    <h4 className="tw-font-light tw-text-base">{label}</h4>
                </div>
            </div>
        </Link>
    );
};

export default NavLinkItem;
